import React from "react";
import { Link,Outlet } from "react-router-dom";
import "./transOwnerCommun.css"
export default function TransOwnerCommun(){

    return (
        <div>
            <div className=" flex flex-row space-x-2 landing-page sm:text-sm lg:text-lg md:font-semibold">                
                <Link to="customers" className=" hover:text-blue-500">Customers</Link>                
                <Link to="farmers" className="hover:text-blue-500">Farmers</Link>
                <Link to="hotelowners" className="hover:text-blue-500">HotelOwners</Link>
                <Link to="admins" className="hover:text-blue-500">Admins</Link>
            </div>
            <Outlet/>
        </div>
    )
}